import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";


export const CssTextField = styled(TextField)({
    width: "100%",
    "& .MuiFormHelperText-root": {
        color: "#e5453b !important",
    },
    "& label": {
        fontSize: 14,
        color: "#2c2f44",
        fontFamily: 'Roboto, sans-serif',
        textTransform: "inherit",
    },
    "& label.MuiInputLabel-shrink": {
        fontSize: "14px",
    },
    "& label.Mui-focused": {
        color: "#638dff",
    },
    "& .MuiInput-underline:after": {
        borderBottomColor: "green",
    },
    "& .MuiOutlinedInput-root": {
        "& fieldset": {
            borderColor: "#c4d8ff",
        },
        "&:hover fieldset": {
            borderColor: "#92afff",
        },
        "&.Mui-disabled": {
            backgroundColor: "#f4f7fb !important",
            "& fieldset": {
                borderColor: "#c4d8ff",
            },
        },
        "&.Mui-error": {
            "& fieldset": {
                borderColor: "#f2a29d !important",
            },
        },
        "&.Mui-focused fieldset": {
            borderColor: "#638dff",
        },
        "& .MuiOutlinedInput-input": {
            padding: "5px 10px",
        },
        "& .MuiOutlinedInput-input.Mui-disabled": {
            color: "#44485a",
            "WebkitTextFillColor": "#44485a",
        },
        "& .MuiIconButton-root": {
            color: "#638dff",
        },
        fontSize: 14,
        fontFamily: 'Roboto, sans-serif',
    },
    "& .MuiInputLabel-asterisk": {
        color: "#e5453b",
    },
    "& div": {
        background: "#FFFFFF",
    },
});

export const CssTextFieldDateTime = styled(TextField)(
    {
        width: "100%",
        "& .MuiFormHelperText-root": {
            color: "#e5453b !important",
        },
        "& label": {
            fontSize: 14,
            color: "#2c2f44",
            fontFamily: 'Roboto, sans-serif',
        },
        "& label.MuiInputLabel-shrink": {
            fontSize: "14px",
            backgroundColor: "white",
        },
        "& label.Mui-focused": {
            color: "#638dff",
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: "green",
        },
        
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderColor: "#c4d8ff",
            },
            "&:hover fieldset": {
                borderColor: "#92afff",
            },
            "&.Mui-disabled": {
                backgroundColor: "#f4f7fb !important",
                "& fieldset": {
                    borderColor: "#c4d8ff",
                },
            },
            "&.Mui-error": {
                "& fieldset": {
                    // borderColor: "#f2a29d !important",
                    borderColor: "#e5453b !important",
                },
            },

            "&.Mui-focused fieldset": {
                borderColor: "#638dff",
            },
            "& .MuiOutlinedInput-input": {
                padding: "5px 10px",
            },
            "& .MuiOutlinedInput-input.Mui-disabled": {
                color: "#44485a",
                "WebkitTextFillColor": "#44485a",
            },
            "& .MuiIconButton-root": {
                color: "#638dff",
            },
            fontSize: 14,
            fontFamily: 'Roboto, sans-serif',
        },
        "& .MuiInputLabel-asterisk": {
            color: "#e5453b",
        },
        "& div": {
            background: "#FFFFFF",
        },
    },
    (props) =>
        props.islabelvisible && {
            "& .MuiOutlinedInput-root": {
                "& .MuiOutlinedInput-input": {
                    width: "auto",
                },
            },
        }
);